import {
  Route,
  Navigate,
  useParams,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from 'react-router-dom';
import I18n from '../../config/i18n';
import AppContainer from '../../layouts/app/containers/AppContainer';

const defaultHomepageLang = '/en';

const getUserLangHomepage = (): string => {
  if (window.navigator && window.navigator.language) {
    const matched = window.navigator.language.match(/^(\w{2})/);
    if (!matched) {
      return defaultHomepageLang;
    }
    const [, userLang] = matched;
    if (I18n.isLocaleSupported(userLang)) {
      return `/${userLang}`;
    }
  }
  return defaultHomepageLang;
};

function ToUserLangHomepage(): JSX.Element {
  return <Navigate to={getUserLangHomepage()} />;
}

function AppForValidLocales(): JSX.Element {
  const { lang } = useParams<'lang'>();

  if (!I18n.isLocaleSupported(lang)) {
    return <ToUserLangHomepage />;
  }

  return <AppContainer />;
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/:lang/*" element={<AppForValidLocales />} />
      <Route path="/*" element={<ToUserLangHomepage />} />
    </>,
  ),
);

export default function Routes(): JSX.Element {
  return <RouterProvider router={router} />;
}
